import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';

import { useAppSelector } from '@/redux/hooks';
import { getUrlFromPathname } from '@/redux/modules/config';
import { track } from '@/utils/amplitude/analytics/core';
import { TrackingEvents, TrackingPayload } from '@/utils/amplitude/analytics/core.types';
import { getAmplitudePageNameFromPath } from '@/utils/getPageNameFromPath';

type TrackPurchaseProtectionFileAClaimPayload = TrackingPayload & {
    description: string;
};

const trackPurchaseProtectionFileAClaimAnalytics = (payload: TrackPurchaseProtectionFileAClaimPayload) => {
    track(TrackingEvents.PurchaseProtection.FileAClaim, payload);
};

export const useTrackPurchaseProtectionFileAClaimAnalytics = () => {
    const { pathname } = useLocation();
    const url = useAppSelector((state) => getUrlFromPathname(state, pathname));

    return useCallback(
        ({ description }: Omit<TrackPurchaseProtectionFileAClaimPayload, 'pageName' | 'url'>) => {
            trackPurchaseProtectionFileAClaimAnalytics({
                description,
                pageName: getAmplitudePageNameFromPath(pathname),
                url,
            });
        },
        [pathname, url]
    );
};
